/* Built In Imports */
import NextLink from 'next/link';
import React from 'react';
/* External Imports */
import { Flex, Link } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@eternal/Components/Ui/LazyLoadImageComponent';
import { refineUrlDomain } from '@eternal/Components/Utility/utils';

/* Services */

/**
 *
 * @param {Object} card
 * @returns
 */
const MusicCard = ({ card }) => {
  return (
    <Flex
      alignItems="center"
      textAlign="center"
      justifyContent="center"
      flex="1"
      maxW={150}
      minW={{ base: '100px', md: '105px' }}
    >
      <NextLink
        href={refineUrlDomain(card.buttonLink)}
        target="_blank"
        passHref
        legacyBehavior
      >
        <Link
          alignItems="center"
          textAlign="center"
          justifyContent="center"
          display="inline-flex"
        >
          <LazyLoadImageComponent
            verticalAlign="middle"
            minW={{ base: '100px', md: '105px' }}
            maxW={{ base: '102px', md: '150px' }}
            maxHeight="40px"
            objectPosition="center"
            w="100%"
            src={card?.mobileImage?.url}
            _hover={{
              content: `url(${card?.thumbnail?.url})`,
              maxW: { base: '102px', md: '150px' },
              maxHeight: '40px',
            }}
          />
        </Link>
      </NextLink>
    </Flex>
  );
};
export default MusicCard;
